import React, { useState, useEffect, useCallback } from "react";
import styles from "./Fortress.module.css";
import ProgressBar from "../components/ProgressBar";
import NavPanel from "../components/NavPanel";
import TapArea from "../components/TapArea";
import NBLogo from "../components/NBLogo";
import Popup from "../components/Popup";

import { useNavigate } from "react-router-dom";

const products = [
  { name: "Product 1", img_main: 'fortress_assets/1_main.png', image: "fortress_assets/1_thumb.png", desc: 'Black with Metallic Gold',  link: 'https://www.newbalance.com/men/shoes/football/?prefn1=seriesNumber&prefv1=Fortress&ICID=CLP_A_PGP_SHOP_FORTRESS_NB4143_MWK',
    dots: [ 
      {x: 79, y: 72, image: 'fortress_assets/1_1.png', feature: 'Superior support, in width sizing', details: 'The Fortress features strategically placed support throughout the upper designed to provide comfort and support at the ankle, and is available in multiple width options - standard, wide, and extra wide – offering superior comfort and fit to every player.'},
      {x: 102, y: 154, image: 'fortress_assets/1_2.png', feature: 'Intelligently crafted', details: 'On the football field, power doesn’t stand still. The Fortress features a stud configuration designed for multi-directional traction and midfoot stability during the high speed, high impact moments that play out on the line and in the box.'}, 
      {x: 314, y: 42, image: 'fortress_assets/1_3.png', feature: 'FuelCell insert', details: 'For hybrid players who demand disruptive speed – edge rushers shedding blocks, tight ends taking on linebackers and defensive backs alike – a sockliner insert utilizes the same technology as our elite racing shoes. FuelCell’s propulsive feeling of energy return provides an extra dimension of underfoot responsiveness.'} ]},
  { name: "Product 2", img_main: 'fortress_assets/2_main.png', image: "fortress_assets/2_thumb.png", desc: 'White with Silver Metalic', link: 'https://www.newbalance.com/men/shoes/football/?prefn1=seriesNumber&prefv1=Fortress&ICID=CLP_A_PGP_SHOP_FORTRESS_NB4143_MWK',
    dots: [
      {x: 79, y: 72, image: 'fortress_assets/2_1.png', feature: 'Superior support, in width sizing', details: 'The Fortress features strategically placed support throughout the upper designed to provide comfort and support at the ankle, and is available in multiple width options - standard, wide, and extra wide – offering superior comfort and fit to every player.'}, 
      {x: 102, y: 154, image: 'fortress_assets/2_2.png', feature: 'Intelligently crafted', details: 'On the football field, power doesn’t stand still. The Fortress features a stud configuration designed for multi-directional traction and midfoot stability during the high speed, high impact moments that play out on the line and in the box.'},
      {x: 314, y: 42, image: 'fortress_assets/2_3.png', feature: 'FuelCell insert', details: 'For hybrid players who demand disruptive speed – edge rushers shedding blocks, tight ends taking on linebackers and defensive backs alike – a sockliner insert utilizes the same technology as our elite racing shoes. FuelCell’s propulsive feeling of energy return provides an extra dimension of underfoot responsiveness.'} ]},
  { name: "Product 3", img_main: 'fortress_assets/3_main.png', image: "fortress_assets/3_thumb.png", desc: 'Black with Magnet', link: 'https://www.newbalance.com/men/shoes/football/?prefn1=seriesNumber&prefv1=Fortress&ICID=CLP_A_PGP_SHOP_FORTRESS_NB4143_MWK',
    dots: [
      {x: 79, y: 72, image: 'fortress_assets/3_1.png', feature: 'Superior support, in width sizing', details: 'The Fortress features strategically placed support throughout the upper designed to provide comfort and support at the ankle, and is available in multiple width options - standard, wide, and extra wide – offering superior comfort and fit to every player.'}, 
      {x: 102, y: 154, image: 'fortress_assets/3_2.png', feature: 'Intelligently crafted', details: 'On the football field, power doesn’t stand still. The Fortress features a stud configuration designed for multi-directional traction and midfoot stability during the high speed, high impact moments that play out on the line and in the box.'},
      {x: 314, y: 42, image: 'fortress_assets/3_3.png', feature: 'FuelCell insert', details: 'For hybrid players who demand disruptive speed – edge rushers shedding blocks, tight ends taking on linebackers and defensive backs alike – a sockliner insert utilizes the same technology as our elite racing shoes. FuelCell’s propulsive feeling of energy return provides an extra dimension of underfoot responsiveness.'} ]},
  { name: "Product 4", img_main: 'fortress_assets/4_main.png', image: "fortress_assets/4_thumb.png", desc: 'Black Cement with Electric Jade and Passion Fruit', link: '',
    dots: [
      {x: 79, y: 72, image: 'fortress_assets/4_1.png', feature: 'Superior support, in width sizing', details: 'The Fortress features strategically placed support throughout the upper designed to provide comfort and support at the ankle, and is available in multiple width options - standard, wide, and extra wide – offering superior comfort and fit to every player.'}, 
      {x: 102, y: 154, image: 'fortress_assets/4_2.png', feature: 'Intelligently crafted', details: 'On the football field, power doesn’t stand still. The Fortress features a stud configuration designed for multi-directional traction and midfoot stability during the high speed, high impact moments that play out on the line and in the box.'},
      {x: 314, y: 42, image: 'fortress_assets/4_3.png', feature: 'FuelCell insert', details: 'For hybrid players who demand disruptive speed – edge rushers shedding blocks, tight ends taking on linebackers and defensive backs alike – a sockliner insert utilizes the same technology as our elite racing shoes. FuelCell’s propulsive feeling of energy return provides an extra dimension of underfoot responsiveness.'} ]},
  { name: "Product 5", img_main: 'fortress_assets/5_main.png', image: "fortress_assets/5_thumb.png", desc: 'Raincloud with Slate Grey and Silver Metallic',  
    dots:[
      {x: 79, y: 72, image: 'fortress_assets/5_1.png', feature: 'Superior support, in width sizing', details: 'The Fortress features strategically placed support throughout the upper designed to provide comfort and support at the ankle, and is available in multiple width options - standard, wide, and extra wide – offering superior comfort and fit to every player.'}, 
      {x: 102, y: 154, image: 'fortress_assets/5_2.png', feature: 'Intelligently crafted', details: 'On the football field, power doesn’t stand still. The Fortress features a stud configuration designed for multi-directional traction and midfoot stability during the high speed, high impact moments that play out on the line and in the box.'},
      {x: 314, y: 42, image: 'fortress_assets/5_3.png', feature: 'FuelCell insert', details: 'For hybrid players who demand disruptive speed – edge rushers shedding blocks, tight ends taking on linebackers and defensive backs alike – a sockliner insert utilizes the same technology as our elite racing shoes. FuelCell’s propulsive feeling of energy return provides an extra dimension of underfoot responsiveness.'} ]},
];


const Fortress = () => {
  const [active, setActive] = useState(0);
  const [fadeIn, setFadeIn] = useState(false);
  const [featureNumber, setFeatureNumber] = useState();
  const activeProduct = products[active]
  const navigate = useNavigate();

  const nbProductPage = "Redirects to product page on New Balance website."
  const nbPage = "Redirects to New Balance website."
  const [popupText, setPopupText] = useState(nbPage)
  const [popupVisible, setPopupVisible] = useState(false);

  useEffect(() => {
    setFadeIn(true);
  }, []);

  const onClickLink =  (link) => {
    umami?.track('Client Link - Fortress shop', { link: link });
    // window.open(link)
    setPopupText(nbProductPage)
    setPopupVisible(true)
  }

  const onClickLogo = () => {
    const link = 'https://www.newbalance.com'
    umami?.track('Client Link - Fortress logo', { link: link });

    setPopupText(nbPage)
    setPopupVisible(true)
  }

  const onPreviousPageClick = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const onNextPageClick = useCallback(() => {
    navigate("/shop-cta");
  }, [navigate]);

  const onClickDot = (id) => {
    if (id == featureNumber) {
      setFeatureNumber(null)
    } else {
      setFeatureNumber(id)
    }    
  }
  
  const renderDots  = () => {
    return(
      (activeProduct.dots || []).map((dot, idx) => (
        ((featureNumber == null) || (featureNumber == idx)) && 
        <div 
          key={`${products[active].name}-dot-${idx}`} 
          style={{ left: `${dot.x}px`, top:  `${featureNumber == null ? dot.y : 190}px` }}
          className={`${styles.redCircle} ${featureNumber == null ? styles.redPulse : '' }`} 
          onClick={() => onClickDot(idx)}>
        </div>    
      ))
    )
  };

  return (
    <div className={styles.fortressPage}>
      <NavPanel onClick={onPreviousPageClick} />
      <NavPanel position='right' onClick={onNextPageClick} />
      
      <ProgressBar current='5' />

      <TapArea style={styles.topLeftNav} onClick={onPreviousPageClick} />
      <TapArea style={styles.bottomLeftNav} onClick={onPreviousPageClick} />

      <TapArea style={styles.topRightNav} onClick={onNextPageClick} />
      <TapArea style={styles.bottomRightNav} onClick={onNextPageClick} />

      <div className={styles.pageHeading}> 
        <NBLogo onClick={ onClickLogo }/>
      </div>  
      <div className={styles.productType}>
        Fortress 
      </div>

      <div className={styles.slogan}> 
        A cleat for the players waging the game’s most intense battles.
      </div> 


      <div className={styles.productListContainer} >
        <div className={styles.detailArea}>
        <div className={`${styles.detailWrapper} ${featureNumber == 0 ? styles.fullWidth : ''}`} >
            <img
              src={products[active].img_main}
              alt={products[active].name}
              className={styles.detailImg}
            />

            { featureNumber != null &&   
              <div className={styles.featureContainer}>
                <img
                  src={activeProduct.dots[featureNumber].image}
                  className={`${styles.detailImg} ${featureNumber == 0 ? styles.fullWidth : ''} ${styles.featuredImage}`}
                  onClick={() => onClickDot(featureNumber)}
                />
              </div>
            }
            { featureNumber != null &&   
              <div className={`${styles.featureText}`} >
                <div className={styles.featureName}> {activeProduct.dots[featureNumber].feature} </div>
                <div className={styles.featureContent}> {activeProduct.dots[featureNumber].details} </div>
              </div> 
            }
            <div className={styles.dots} >
              { renderDots() }
            </div> 
          </div>
        </div>
        <div className={styles.productList}>
          {products.map((product, idx) => (
            <div
              key={product.name}
              className={idx === active ? `${styles.productItem} ${styles.active}` : styles.productItem}
              onClick={() => { setActive(idx) ; setFeatureNumber(null) }}
            >
              <img
                src={product.image}
                alt={product.name}
                className={styles.productThumb}
              />
            </div>
          ))}
        </div>
      </div>
      <div className={styles.productDesc}> 
        {products[active].desc}
      </div>

      <a
        onClick={() => onClickLink('https://www.newbalance.com/men/shoes/football/?prefn1=seriesNumber&prefv1=Fortress&ICID=CLP_A_PGP_SHOP_FORTRESS_NB4143_MWK')}  
        className={styles.btnShop}>        
        Shop
      </a>

      <div className={`${styles.text} ${fadeIn ? styles.fadeIn : ""}`}>Because the game deserves better.</div>

      { featureNumber != null &&   
        <div className={styles.overlay} onClick={() => setFeatureNumber(null)}></div>
      }

      <Popup visible={popupVisible} onHide={() => setPopupVisible(false)}>
        {popupText}
      </Popup>
    </div>
  );
};

export default Fortress; 